class MobileMenu extends HTMLElement {
    constructor() {
        super();
        this.closeButtons = this.querySelectorAll('[data-close-menu]');
        this.inner = this.querySelector('.mobile-menu__inner');

        // Bind methods
        this.close = this.close.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.focusTrap = this.focusTrap.bind(this);
        this.initToggle = this.initToggle.bind(this);

        // Add event listeners for closing
        this.closeButtons.forEach(button => button.addEventListener('click', this.close));

        this.focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]';
    }

    connectedCallback() {
        this.initToggle();
        // In case the toggle button is rendered after this element (e.g. at bottom of body)
        if (!this.toggle) {
            document.addEventListener('DOMContentLoaded', this.initToggle);
            // Also try immediately just in case
            setTimeout(this.initToggle, 100);
        }
    }

    initToggle() {
        if (!this.toggle) {
            this.toggle = document.querySelector('[aria-controls="MobileMenu"]');
            if (this.toggle) {
                this.toggle.addEventListener('click', () => this.open());
            }
        }
    }

    open() {
        this.setAttribute('aria-hidden', 'false');
        if (this.toggle) {
            this.toggle.setAttribute('aria-expanded', 'true');
        }
        document.body.style.overflow = 'hidden'; // Prevent background scrolling

        document.addEventListener('keyup', this.onKeyUp);
        document.addEventListener('keydown', this.focusTrap);

        // Focus on the first focusable element inside the menu for accessibility
        if (this.inner) {
            const firstFocusable = this.inner.querySelector(this.focusableElementsString);
            if (firstFocusable) {
                setTimeout(() => firstFocusable.focus(), 100);
            }
        }
    }

    close() {
        this.setAttribute('aria-hidden', 'true');
        if (this.toggle) {
            this.toggle.setAttribute('aria-expanded', 'false');
            // Return focus to the toggle button
            this.toggle.focus();
        }
        document.body.style.overflow = ''; // Restore scrolling

        document.removeEventListener('keyup', this.onKeyUp);
        document.removeEventListener('keydown', this.focusTrap);
    }

    onKeyUp(event) {
        if (event.key === 'Escape') this.close();
    }

    focusTrap(e) {
        if (e.key !== 'Tab' || !this.inner) return;

        const focusableElements = Array.from(this.inner.querySelectorAll(this.focusableElementsString))
            .filter(el => el.tabIndex !== -1);

        if (focusableElements.length === 0) return;

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (e.shiftKey) { // Shift + Tab
            if (document.activeElement === firstElement) {
                lastElement.focus();
                e.preventDefault();
            }
        } else { // Tab
            if (document.activeElement === lastElement) {
                firstElement.focus();
                e.preventDefault();
            }
        }
    }
}

if (!customElements.get('mobile-menu')) {
    customElements.define('mobile-menu', MobileMenu);
}
